import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Repository } from 'typeorm';
import { appSettings} from '../../../../config';
import { StockInEntity } from './stock-in.entity';
import { ReportTypeENum, StockInResDto, StockInResponseData, StockInData } from '@gtpl/shared-models/analytics-data';
import { StockInRequestDto } from './dto/stock-in.request.dto';
import { StockInObj } from './dto/stock-obj';
import { CommonResponse, ExpectedStockInOutResponse } from '@gtpl/shared-models/warehouse-management'
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import { AnalyticsUnitRequest } from './dto/analytics-unit.request';

const dashboardStockInTable = appSettings.analytics_db + '.stock_in';
const dashboardStockOutTable = appSettings.analytics_db + '.stock_out';
let moment = require('moment');
moment().format();
@Injectable()
export class WarehouseService {
    constructor(@InjectRepository(StockInEntity) private stockInRepository: Repository<StockInEntity>){}

    async getStockInfo(dtoObj: StockInRequestDto): Promise <StockInResponseData>{
        try {  
            const manager = getManager();  
            let queryIn='';  
            let queryOut='';  
            let monthNo=0;           
            // const quarterInfo=3;
            if(!dtoObj.month){
                const dateData = new Date();
                monthNo = dateData.getMonth();
            }else{
                monthNo=dtoObj.month;
            }
           
            let yearNo=0;
            if(!dtoObj.year){
                const dateData = new Date();
                yearNo = dateData.getFullYear();
            }else{
                yearNo=dtoObj.year;
            }
            const names = []; 
            const namesData = [];

            let quarterName;
            const qunarterCount = {1 : 'quarter1',  2 : 'quarter1', 3 : 'quarter1', 4 : 'quarter2', 5 : 'quarter2', 6 : 'quarter2', 7 : 'quarter3', 8 : 'quarter3', 9 : 'quarter3', 10 : 'quarter4', 11 : 'quarter4', 12 : 'quarter4'};
            const monthData ={1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'};
            let mapKey;
            let querySelect;
            let queryWhere;
            let queryGroup;
            let queryOutSelect;
            let queryOutWhere;
            let queryOutGroup;
            const monthInfo=monthNo-1;
            let allNames;
            // const kg=2.20462;
            // const gm=0.00220462;
            // const oz=0.0625;
           
            /** For Storing Names of the Series Data*/
            if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                /** Assigning all dateData */               
                const date = new Date(yearNo, monthInfo, 1);   
                while (date.getMonth() === monthInfo) {
                    names.push(moment(new Date(date)).format('YYYY-MM-DD'));                    
                    date.setDate(date.getDate() + 1);
                }

                /**Day QueryFilter */
                querySelect = 'DATE(reporting_date) AS reportedDate';
                queryGroup = 'DATE(reporting_date)';
                queryWhere = 'MONTH(reporting_date)='+monthNo+'';

                queryOutSelect = 'DATE(created_at) AS reportedDate';
                queryOutGroup = 'DATE(created_at)';
                queryOutWhere = 'MONTH(created_at)='+monthNo+'';

                allNames = names;
            }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){
                let month;      
                if (monthNo < 10)
                month = "0" + monthNo;            
                const date = "01." + month + "." + yearNo;
                const first = moment(date, 'dd.MM.yyyy').startOf('month').week();
                const last = moment(date, 'dd.MM.yyyy').endOf('month').week();
                for (let i = first; i < last; i++) {
                    namesData.push(i);
                    names.push(i + " " + monthData[monthNo]);
                } 
                /** Month QueryFilter */
                querySelect = 'WEEK(reporting_date) AS reportedDate';
                queryGroup = 'WEEK(reporting_date)';
                queryWhere = 'MONTH(reporting_date)='+monthNo+'';

                queryOutSelect = 'WEEK(created_at) AS reportedDate';
                queryOutGroup = 'WEEK(created_at)';
                queryOutWhere = 'MONTH(created_at)='+monthNo+'';

                allNames = namesData;
            }else{
                const quarterNames = ['Jan - Mar', 'Apr - Jun', 'Jul - Sep', 'Oct - Dec'];
                const quarterData = ['quarter1', 'quarter2', 'quarter3', 'quarter4'];
                for (const quanrter of quarterNames) {
                    names.push(quanrter + " " + yearNo);                
                }
                /** Year QueryFilter */
                querySelect = 'MONTH(reporting_date) AS reportedDate';
                queryGroup = 'MONTH(reporting_date)';
                queryWhere = 'YEAR(reporting_date)='+yearNo+'';

                queryOutSelect = 'MONTH(created_at) AS reportedDate';
                queryOutGroup = 'MONTH(created_at)';
                queryOutWhere = 'YEAR(created_at)='+yearNo+'';


                allNames = quarterData;
            }           
           
            queryIn = `SELECT `+querySelect+`,ROUND(SUM(IF(stock_type='dummy',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS dummy,      
            ROUND(SUM(IF(stock_type='SaleOrder',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS saleorder,  
            ROUND(SUM(IF(stock_type='anticipated',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS anticipated,
            ROUND(SUM(IF(stock_type='superDummy',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS superDummy  FROM `+dashboardStockInTable+` Where `+queryWhere;
            if(dtoObj.unitId != "5"){
                queryIn = queryIn + ` AND unit_id= '`+dtoObj.unitId;
            }
            queryIn = queryIn + ` GROUP BY `+queryGroup+``; 
            const reportDataIn = await manager.query(queryIn);
            // console.log(reportDataIn);
            queryOut = `SELECT `+queryOutSelect+`,ROUND(SUM(IF(stock_type='dummy',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS dummy,      
            ROUND(SUM(IF(stock_type='SaleOrder',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS saleorder,  
            ROUND(SUM(IF(stock_type='anticipated',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS anticipated,
            ROUND(SUM(IF(stock_type='superDummy',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS superDummy FROM `+dashboardStockOutTable+` WHERE `+queryOutWhere;
            if(dtoObj.unitId != "5"){
                queryOut = queryOut + ` AND unit_id= '`+dtoObj.unitId;
            }
            queryOut = queryOut + ` GROUP BY `+queryOutGroup+``; 
            const reportDataOut = await manager.query(queryOut);
            // console.log(reportDataOut);
            if(reportDataIn.length<1 && reportDataOut.length<1){
                throw new ErrorResponse(99998, 'No Records Found');
            }   
              
             /** Fetching  Stock In Informaiton */
            const stockInDataMap = new Map<string, StockInObj>();
            for(const stockInData of reportDataIn){
                if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                    const mapKey = moment(stockInData.reportedDate).format('YYYY-MM-DD');
                    if(!stockInDataMap.has(mapKey)){
                        const stockInDataObj = new StockInObj();
                
                        stockInDataObj.anticipated = stockInData.anticipated;                
                        stockInDataObj.saleorder = stockInData.saleorder;                
                        stockInDataObj.dummy = stockInData.dummy;                
                        stockInDataObj.superDummy = stockInData.superDummy; 
                        stockInDataMap.set(mapKey, stockInDataObj);   
                    }else{
                        stockInDataMap.get(mapKey).dummy += stockInData.dummy;     
                        stockInDataMap.get(mapKey).saleorder += stockInData.saleorder;     
                        stockInDataMap.get(mapKey).anticipated += stockInData.anticipated;     
                        stockInDataMap.get(mapKey).superDummy += stockInData.superDummy;     
                    }
                }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){ 
                    const mapKey = stockInData.reportedDate;
                    if(!stockInDataMap.has(mapKey)){
                        const stockInDataObj = new StockInObj();
                
                        stockInDataObj.anticipated = stockInData.anticipated;                
                        stockInDataObj.saleorder = stockInData.saleorder;                
                        stockInDataObj.dummy = stockInData.dummy;                
                        stockInDataObj.superDummy = stockInData.superDummy; 
                        stockInDataMap.set(mapKey, stockInDataObj);   
                    }else{
                        stockInDataMap.get(mapKey).dummy += stockInData.dummy;     
                        stockInDataMap.get(mapKey).saleorder += stockInData.saleorder;     
                        stockInDataMap.get(mapKey).anticipated += stockInData.anticipated;     
                        stockInDataMap.get(mapKey).superDummy += stockInData.superDummy;     
                    }
                }else{                     
                    quarterName=qunarterCount[stockInData.reportedDate];
                    if(!stockInDataMap.has(quarterName)){
                        const stockInDataObj = new StockInObj();                        
                        stockInDataObj.anticipated = stockInData.anticipated;                
                        stockInDataObj.saleorder = stockInData.saleorder;                
                        stockInDataObj.dummy = stockInData.dummy;                
                        stockInDataObj.superDummy = stockInData.superDummy; 
                        stockInDataMap.set(quarterName, stockInDataObj);
                    }else{
                        stockInDataMap.get(quarterName).dummy += stockInData.dummy;     
                        stockInDataMap.get(quarterName).saleorder += stockInData.saleorder;     
                        stockInDataMap.get(quarterName).anticipated += stockInData.anticipated;     
                        stockInDataMap.get(quarterName).superDummy += stockInData.superDummy; 
                    }
                }
            }
            // console.log(stockInDataMap);
            // console.log(names);
            const dashboardStockInData = new StockInData();
            dashboardStockInData.anticipated = [];
            dashboardStockInData.saleorder = [];
            dashboardStockInData.dummy = [];
            dashboardStockInData.superDummy = [];            
            allNames.forEach(eachName => {
                const stockInObj = stockInDataMap.get(eachName); 
                dashboardStockInData.anticipated.push(stockInObj? stockInObj.anticipated : 0); 
                dashboardStockInData.saleorder.push(stockInObj? stockInObj.saleorder : 0);
                dashboardStockInData.dummy.push(stockInObj? stockInObj.dummy : 0);  
                dashboardStockInData.superDummy.push(stockInObj? stockInObj.superDummy : 0);  
            })

           /** Fetching  Stock Out Informaiton */
            const stockOutDataMap = new Map<string, StockInObj>();
            for(const stockOutData of reportDataOut){
                if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                    const mapKey = moment(stockOutData.reportedDate).format('YYYY-MM-DD');
                    if(!stockOutDataMap.has(mapKey)){
                        const stockOutDataObj = new StockInObj();
                
                        stockOutDataObj.anticipated = stockOutData.anticipated;                
                        stockOutDataObj.saleorder = stockOutData.saleorder;                
                        stockOutDataObj.dummy = stockOutData.dummy;                
                        stockOutDataObj.superDummy = stockOutData.superDummy; 
                        stockOutDataMap.set(mapKey, stockOutDataObj);   
                    }else{
                        stockOutDataMap.get(mapKey).dummy += stockOutData.dummy;     
                        stockOutDataMap.get(mapKey).saleorder += stockOutData.saleorder;     
                        stockOutDataMap.get(mapKey).anticipated += stockOutData.anticipated;     
                        stockOutDataMap.get(mapKey).superDummy += stockOutData.superDummy;     
                    }
                }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){ 
                    const mapKey = stockOutData.reportedDate;
                    if(!stockOutDataMap.has(mapKey)){
                        const stockOutDataObj = new StockInObj();                
                        stockOutDataObj.anticipated = stockOutData.anticipated;                
                        stockOutDataObj.saleorder = stockOutData.saleorder;                
                        stockOutDataObj.dummy = stockOutData.dummy;                
                        stockOutDataObj.superDummy = stockOutData.superDummy; 
                        stockOutDataMap.set(mapKey, stockOutDataObj);   
                    }else{
                        stockOutDataMap.get(mapKey).dummy += stockOutData.dummy;     
                        stockOutDataMap.get(mapKey).saleorder += stockOutData.saleorder;     
                        stockOutDataMap.get(mapKey).anticipated += stockOutData.anticipated;     
                        stockOutDataMap.get(mapKey).superDummy += stockOutData.superDummy;     
                    }
                }else{                     
                    quarterName=qunarterCount[stockOutData.reportedDate];   
                    if(!stockOutDataMap.has(quarterName)){
                        const stockOutDataObj = new StockInObj();                        
                        stockOutDataObj.anticipated = stockOutData.anticipated;                
                        stockOutDataObj.saleorder = stockOutData.saleorder;                
                        stockOutDataObj.dummy = stockOutData.dummy;                
                        stockOutDataObj.superDummy = stockOutData.superDummy; 
                        stockOutDataMap.set(quarterName, stockOutDataObj);   
                    }else{
                        stockOutDataMap.get(quarterName).dummy += stockOutData.dummy;     
                        stockOutDataMap.get(quarterName).saleorder += stockOutData.saleorder;     
                        stockOutDataMap.get(quarterName).anticipated += stockOutData.anticipated;     
                        stockOutDataMap.get(quarterName).superDummy += stockOutData.superDummy;     
                    }
                }
            }

            const dashboardStockOutData = new StockInData();
            dashboardStockOutData.anticipated = [];
            dashboardStockOutData.saleorder = [];
            dashboardStockOutData.dummy = [];
            dashboardStockOutData.superDummy = [];
            allNames.forEach(eachName => {
                const stockOutObj = stockOutDataMap.get(eachName); 
                dashboardStockOutData.anticipated.push(stockOutObj? stockOutObj.anticipated : 0); 
                dashboardStockOutData.saleorder.push(stockOutObj? stockOutObj.saleorder : 0);
                dashboardStockOutData.dummy.push(stockOutObj? stockOutObj.dummy : 0);  
                dashboardStockOutData.superDummy.push(stockOutObj? stockOutObj.superDummy : 0);  
            })

            const dashboardStockData = new StockInResDto(names, dashboardStockInData, dashboardStockOutData);
            return new StockInResponseData(true, 10000, 'Data Retrieved Successfully.', dashboardStockData);
                       
        } catch (error) {
            console.log(error);
            return error
        }
    }
    async getTodaysStockOutSOs(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select SUM(so.job_cartons) AS jobCartonsCnt from "+appSettings.analytics_db+".stock_out so where date(so.created_at) = Date(Now())";
            if(req.unitId && req.unitId !=5){
                query = query + ' and so.unit_id = ' + req.unitId
            }
            const queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock Out transcations retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }catch (error) {
            console.log(error);
            return error
        }
    }
    async getrecentFiveStockIns(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select si.created_at AS date, si.reporting_log_id AS reportingLogId,si.po_number AS poNumber,si.variant_code AS variantCode, si.reported_cases AS reportedCases,si.rack_position_code AS rackPositionCode,si.unit_code AS unitCode,si.unit_id from "+appSettings.analytics_db+".stock_in si  WHERE si.reporting_log_id > 0 ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and si.unit_id = ' + req.unitId
            }
            query = query + ' order by si.reporting_log_id desc limit 5'
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock In transactions retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getrecentFiveStockOuts(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select so.job_purpose AS jobPurpose,so.fork_lift_job_id as forkLiftJobId,so.fork_lift_item_id AS forkLiftItem_id,so.po_number AS poNumber, SUM(so.job_cartons) AS jobCartons, so.current_position_code AS currentPositionCode,so.unit_code AS unitCode,so.created_at AS createdAt,si.variant_code as variantCode from "+appSettings.analytics_db+".stock_out so LEFT JOIN " + appSettings.analytics_db + ".stock_in si ON si.sale_order_item_id = so.sale_order_item_id WHERE fork_lift_item_id > 0 ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and so.unit_id = ' + req.unitId
            }
            query = query + ' group by so.fork_lift_job_id order by so.fork_lift_job_id desc limit 5 '
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock Out transcations retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getTodayStockTransfers(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select SUM(so.job_cartons) AS jobCartonsCnt from "+appSettings.analytics_db+".stock_out so where date(so.created_at) = Date(Now()) and so.job_purpose = 'stockTransfer'";
            if(req.unitId && req.unitId !=5){
                query = query + ' and so.unit_id = ' + req.unitId
            }
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock transactions retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getCartonsInWayRacks(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select SUM(total_cartons) AS totalCartons from "+appSettings.analytics_db+".stock s where status = 'StockIn' and rack_type = true";
            if(req.unitId && req.unitId !=5){
                query = query + ' and s.unit_id = ' + req.unitId;
            }
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Way Racks Info retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getLongRunningDummyStock(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = `SELECT si.po_number AS poNumber, si.reported_cases AS cases, si.variant_code AS variantCode, si.rack_position_code AS rackPositionCode, si.unit_code AS unitCode,si.reporting_date as reportingDate FROM `+appSettings.analytics_db+`.stock_in si LEFT JOIN `+appSettings.analytics_db+`.stock s ON s.stock_id = si.stock_id WHERE si.stock_type = "dummy" AND DATE(reporting_date) < DATE( DATE_SUB( NOW() , INTERVAL 180 DAY ) ) AND s.status = "StockIn"`;
            if(req.unitId && req.unitId !=5){
                query = query + ' and s.unit_id = ' + req.unitId;
            }
            let queryResult = await manager.query(query)
            if(queryResult.length > 0){
                return new CommonResponse(true,1001,"Dead Stock retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getWarehouseCapacity(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "SELECT u.unit_name AS unitName,SUM(IF(rp.occupancy='Assigned',1,0)) AS assignedCount, SUM(IF(rp.occupancy='Not Occupied',1,0)) AS notOccupiedCount,SUM(IF(rp.occupancy='Occupied',1,0)) AS OccupiedCount,(SUM(IF(rp.occupancy='Assigned',1,0)) + SUM(IF(rp.occupancy='Not Occupied',1,0)) + SUM(IF(rp.occupancy='Occupied',1,0)) ) as total FROM "+appSettings.masters_db+".rack_position rp  LEFT JOIN "+appSettings.masters_db+".unitcodes u ON u.unit_code_id = rp.plant_id LEFT JOIN "+appSettings.masters_db+".rack r ON r.rack_id = rp.rack_id WHERE r.rack_status = FALSE AND rp.is_active = TRUE ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and rp.plant_id = ' + req.unitId;
            }
            query = query + ` GROUP BY rp.plant_id ORDER BY u.unit_name , rp.occupancy `
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Warehouse Capacity retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getPOsProductionAbove70Perc(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "select count(*) AS count from "+appSettings.analytics_db+".sale_order so LEFT JOIN  " + appSettings.analytics_db + ".stock s ON s.sale_order_id = so.sale_order_id where so.production_percentage > 70 and so.status Not In ('CLOSED','CANCELLED')";
            if(req.unitId && req.unitId !=5){
                query = query + ' and s.unit_id = ' + req.unitId;
            }
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Production above 70% retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getTransferdSOsStock(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "select sale_order_id AS saleOrder_id from "+appSettings.sales_db+".so_transfer_log stl where date(created_at) = date(now())";
            let queryResult = await manager.query(query)
            let response = [];
            if(queryResult.length > 0){
                for(const res of queryResult){
                    let stockIds = `Select CONCAT("'",sl.stockId,"',") as stockIds from `+appSettings.warehouse_db+`.stock_log sl where stock_id =" + res.saleOrderId+" and date(created_at) = date(now())`;
                    let stockIdsResult = await manager.query(stockIds);
                    let transferedStock = "select SUM(total_cartons) AS totalCartons from "+appSettings.analytics_db+".stock s where s.stock_id IN ("+stockIdsResult[0].stockIds+")"; 
                    let transferedStockResult = await manager.query(transferedStock);
                    response.push(transferedStockResult);
                }
            }
            if(response.length > 0) {
                return new CommonResponse(true,1001,"Transfered SO's stock retrived successfully",response);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getRepackingEfficiency(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let getRepackingStock = "Select po_number AS poNumber,job_cartons AS jobCartons,issued_quantity AS issuedQuantity,received_quantity AS receivedQuantity,(issued_quantity - received_quantity) as efficiency  from "+appSettings.analytics_db+".stock_out where job_purpose = 'repacking' and status = 'completed'";
            console.log('##############',getRepackingStock)
            if(req.unitId && req.unitId !=5){
                getRepackingStock = getRepackingStock + ' and stock_out.unit_id = ' + req.unitId;
            }
            let getRepackingStockResult = await manager.query(getRepackingStock);
            if(getRepackingStockResult.length > 0) {
                return new CommonResponse(true,1001,"Repacking efficiency retrived successfully",getRepackingStockResult);
                
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }catch (error) {
            return error
        }
    }
    async getExpectedStockInsAndStockOuts(req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse>{
        try{
            let res:any = []
            const manager = getManager();  
            let expectedStockIns = "SELECT SUM(si.job_cases - si.reported_cases) AS inCartons FROM "+appSettings.analytics_db+".`sale_order_items` si LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = si.sale_order_id LEFT JOIN "+appSettings.analytics_db+".stock st ON st.sale_order_id = si.sale_order_id WHERE DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') AND si.reported_cases < si.job_cases  limit 1";
            if(req.unitId && req.unitId !=5){
                expectedStockIns = expectedStockIns + ' and st.unit_id = ' + req.unitId;
            }
            let expectedStockInCnt = await manager.query(expectedStockIns);
            console.log("expectedStockInCnt" + expectedStockInCnt[0].inCartons);
            let expectedLocationsQuery = "SELECT SUM((si.job_cases - si.reported_cases)/si.pallet_capacity) AS inLocationsCnt FROM "+appSettings.analytics_db+".`sale_order_items` si LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = si.sale_order_id WHERE DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') AND si.reported_cases < si.job_cases  limit 1";
            let expectedLocations = await manager.query(expectedLocationsQuery);
            console.log("expectedLocations" + expectedLocations[0]);

            let expectedStockOuts = "SELECT SUM(st.total_cartons) AS outCartons FROM "+appSettings.analytics_db+".stock st LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = st.sale_order_id WHERE st.status = 'StockIn' AND DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') limit 1";
            let expectedStockOutCnt = await manager.query(expectedStockOuts);
            console.log("expectedStockOutCnt" + expectedStockOutCnt[0]);

            let expectedavailLocations = "SELECT COUNT(*) AS outLocationscnt FROM "+appSettings.analytics_db+".stock st LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = st.sale_order_id WHERE st.status = 'StockIn' AND DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') limit 1";
            let expectedavailableLocations = await manager.query(expectedavailLocations);
            console.log("expectedavailableLocations" + expectedavailableLocations[0]);

            if(expectedStockInCnt[0].inCartons > 0){
                return new ExpectedStockInOutResponse(true,1001,"Expected Stock In's & Out Locations retrived Successfully ",expectedStockInCnt[0].inCartons,expectedLocations[0].inLocationsCnt,expectedStockOutCnt[0].outCartons,expectedavailableLocations[0].outLocationscnt);
            }
            else{
                return new ExpectedStockInOutResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getWarehouseLifeCycle(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        const manager = getManager();  
        try{
            let stockInQuery = "SELECT 'SO Stock IN' AS lifeCycleStatus, COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`, ((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total FROM "+appSettings.analytics_db+".stock WHERE `status` = 'StockIn'";
            if(req.unitId && req.unitId !=5){
                stockInQuery = stockInQuery + ' and stock.unit_id = ' + req.unitId;
            }
            let stockInSOs = await manager.query(stockInQuery);
            let stockOutquery = "SELECT 'SO Stock Out' AS lifeCycleStatus,COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`,((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total FROM "+appSettings.analytics_db+".stock WHERE STATUS = 'StockOut'";
            if(req.unitId && req.unitId !=5){
                stockOutquery = stockOutquery + ' and stock.unit_id = ' + req.unitId;
            }
            let stockOutSOs = await manager.query(stockOutquery);
            // let stockBeyondETDQuery = "Select count(sale_order_id) as stockBeyondETD from "+appSettings.analytics_db+".stock s left join "+appSettings.analytics_db+".sale_order so so.sale_order_id = s.sale_order_id where date(";

            let stockMovedBeyondEtdQuery = "SELECT 'Stock Not Moved Beyond ETD' AS lifeCycleStatus,SUM(IF(so.factoryId = 1, 1, 0)) AS kkd,SUM(IF(so.factoryId = 2, 1, 0)) AS unitOne,SUM(IF(so.factoryId = 3, 1, 0)) AS unitTwo,((SUM(IF(so.factoryId = 1, 1, 0))) + (SUM(IF(so.factoryId = 2, 1, 0))) + (SUM(IF(so.factoryId = 3, 1, 0)))) as total FROM "+appSettings.sales_db+".`sale_order_track` s LEFT JOIN "+appSettings.sales_db+".`so_invoice_details` so ON so.sale_order_id = s.sale_order_id WHERE DATE(s.dispatched_date) > DATE(so.act_edl_date)";
            if(req.unitId && req.unitId !=5){
                stockMovedBeyondEtdQuery = stockMovedBeyondEtdQuery + ' and so.factoryId = ' + req.unitId;
            }
            let stockMovedBeyondEtd = await manager.query(stockMovedBeyondEtdQuery);

            let stockMovedBeforeEtdQuery = "SELECT 'Stock Moved Before ETD' AS lifeCycleStatus,SUM(IF(so.factoryId = 1, 1, 0)) AS kkd,SUM(IF(so.factoryId = 2, 1, 0)) AS unitOne,SUM(IF(so.factoryId = 3, 1, 0)) AS unitTwo,((SUM(IF(so.factoryId = 1, 1, 0))) + (SUM(IF(so.factoryId = 2, 1, 0))) + (SUM(IF(so.factoryId = 3, 1, 0)))) as total FROM "+appSettings.sales_db+".`sale_order_track` s LEFT JOIN "+appSettings.sales_db+".`so_invoice_details` so ON so.sale_order_id = s.sale_order_id WHERE DATE(s.dispatched_date) < DATE(so.act_edl_date)";
            if(req.unitId && req.unitId !=5){
                stockMovedBeforeEtdQuery = stockMovedBeforeEtdQuery + ' and so.factoryId = ' + req.unitId;
            }
            let stockMovedBeforeEtd = await manager.query(stockMovedBeforeEtdQuery);

            let stockMovedOnTimeQuery = "SELECT 'Stock Moved OnTime' AS lifeCycleStatus,SUM(IF(so.factoryId = 1, 1, 0)) AS kkd,SUM(IF(so.factoryId = 2, 1, 0)) AS unitOne,SUM(IF(so.factoryId = 3, 1, 0)) AS unitTwo,((SUM(IF(so.factoryId = 1, 1, 0))) + (SUM(IF(so.factoryId = 2, 1, 0))) + (SUM(IF(so.factoryId = 3, 1, 0)))) as total FROM "+appSettings.sales_db+".`sale_order_track` s LEFT JOIN "+appSettings.sales_db+".`so_invoice_details` so ON so.sale_order_id = s.sale_order_id WHERE DATE(s.dispatched_date) = DATE(so.act_edl_date)";
            if(req.unitId && req.unitId !=5){
                stockMovedOnTimeQuery = stockMovedOnTimeQuery + ' and so.factoryId = ' + req.unitId;
            }
            let stockMovedOnTime = await manager.query(stockMovedOnTimeQuery);

            let dummyStockInQuery = "select 'Without SO Stock IN' AS lifeCycleStatus, COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`,((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total from "+appSettings.warehouse_db+".stock where `status` = 'StockIn' and stock_type = 'dummy'";
            if(req.unitId && req.unitId !=5){
                dummyStockInQuery = dummyStockInQuery + ' and stock.unit_id = ' + req.unitId;
            }
            let dummyStockInSOs = await manager.query(dummyStockInQuery);

            let dummyStockOutquery = "select 'Without SO Stock Out' AS lifeCycleStatus, COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`,((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total from "+appSettings.warehouse_db+".stock where `status` = 'StockOut' and stock_type = 'dummy'";
            if(req.unitId && req.unitId !=5){
                dummyStockOutquery = dummyStockOutquery + ' and stock.unit_id = ' + req.unitId;
            }
            let dummyStockOutSOs = await manager.query(dummyStockOutquery);

            let deadStockBeyond30daysQuery = `SELECT 'Dummy Stock Not Moved Beyond 30days' AS lifeCycleStatus,IF(s.unit_id = 1, COUNT(DISTINCT s.sale_order_id), 0) AS kkd,IF(s.unit_id = 2, COUNT(DISTINCT s.sale_order_id), 0) AS unitOne,IF(s.unit_id = 3, COUNT(DISTINCT s.sale_order_id), 0) AS unitTwo,((COUNT(DISTINCT(IF(s.unit_id =1 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(s.unit_id =2 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(s.unit_id =3 ,s.sale_order_id,0))) - 1)) as total FROM `+appSettings.analytics_db+`.stock_in si LEFT JOIN `+appSettings.analytics_db+`.stock s ON s.stock_id = si.stock_id WHERE si.stock_type = "dummy" AND DATE(reporting_date) < DATE(NOW()) - INTERVAL 30 DAY AND s.status = "StockIn"`;
            if(req.unitId && req.unitId !=5){
                deadStockBeyond30daysQuery = deadStockBeyond30daysQuery + ' and si.unit_id = ' + req.unitId;
            }
            let deadStockBeyond30days = await manager.query(deadStockBeyond30daysQuery)

            let deadStockBeyond60daysQuery = `SELECT 'Dummy Stock Not Moved Beyond 60days' AS lifeCycleStatus,IF(si.unit_id = 1, COUNT(DISTINCT s.sale_order_id), 0) AS kkd,IF(si.unit_id = 2, COUNT(DISTINCT s.sale_order_id), 0) AS unitOne,IF(si.unit_id = 3, COUNT(DISTINCT s.sale_order_id), 0) AS unitTwo,((COUNT(DISTINCT(IF(si.unit_id =1 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(si.unit_id =2 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(si.unit_id =3 ,s.sale_order_id,0))) - 1)) as total FROM `+appSettings.analytics_db+`.stock_in si LEFT JOIN `+appSettings.analytics_db+`.stock s ON s.stock_id = si.stock_id WHERE si.stock_type = "dummy" AND DATE(reporting_date) < DATE(NOW()) - INTERVAL 60 DAY AND s.status = "StockIn"`;
            if(req.unitId && req.unitId !=5){
                deadStockBeyond60daysQuery = deadStockBeyond60daysQuery + ' and si.unit_id = ' + req.unitId;
            }
            let deadStockBeyond60days = await manager.query(deadStockBeyond60daysQuery)

            let response = [...stockInSOs,...stockOutSOs,...stockMovedBeyondEtd,...stockMovedBeforeEtd,...stockMovedOnTime,...dummyStockInSOs,...dummyStockOutSOs,...deadStockBeyond30days,...deadStockBeyond60days];
            
            return new CommonResponse(true,1001,"Life Cycle status retrived successfully",response)

        }catch (error) {



            return error
        }
    }
    async getTop10DummyProducts(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        const manager = getManager();  
        try{
            let query = "SELECT variant_code AS product,varient_id, SUM(stockin_qunatity) as qty,ROUND(SUM(IF(uom_code = 'KG' ,(stockin_qunatity*pouches*pouch_weight* 2.20462),IF(uom_code = 'OZ', (stockin_qunatity*pouches*pouch_weight* 0.0625),IF(uom_code = 'GM' ,(stockin_qunatity*pouches*pouch_weight* 0.0022),IF(uom_code = 'LB',(stockin_qunatity*pouches*pouch_weight),(stockin_qunatity*pouches*pouch_weight))))))) AS cnt FROM "+appSettings.analytics_db+".stock WHERE stock_type = 'dummy' AND STATUS = 'StockIn' ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and unit_id = '+ req.unitId;
            }
            query = query + ` GROUP BY varient_id ORDER BY cnt DESC LIMIT 10 `
            let queryResult = await manager.query(query);
            if(queryResult.length > 0){
                return new CommonResponse(true,1001,"Data retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1001,"No data found",queryResult);
            }
        }catch (error) {
            return error
        }
    }


    
}
